module.exports = __webpack_public_path__ + "media/store/fonts/ft-menu-4-e295b0152c2553ddc86fa4346df716e2.woff";